export default "__VITE_ASSET__DoGTAkwi__"